module.exports = __webpack_public_path__ + "img/foster_icon1.7ce36d16.png";